import React from 'react';
import ClientInquiryForm from './ClientInquiryForm';
import SEOSection from './components/SEOSection';

function App() {
  return (
    <div className="min-h-screen bg-slate-50 selection:bg-indigo-500 selection:text-white relative overflow-hidden">
      
      {/* Subtle Light Background Accents */}
      <div className="fixed top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-indigo-100/50 blur-[100px] pointer-events-none" />
      <div className="fixed bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-emerald-100/50 blur-[100px] pointer-events-none" />

      {/* Structural Wrapper */}
      <main className="relative z-10">
        {/* Navigation Placeholder */}
        <nav className="p-8 max-w-7xl mx-auto flex justify-between items-center">
          <div className="text-xl font-black text-slate-900 tracking-tighter">
            SR<span className="text-indigo-600">D</span>
          </div>
          <div className="hidden md:flex gap-8 text-[10px] uppercase tracking-[0.3em] font-black text-slate-400">
            <span className="hover:text-indigo-600 cursor-pointer transition-colors">Development</span>
            <span className="hover:text-indigo-600 cursor-pointer transition-colors">Strategy</span>
            <span className="hover:text-indigo-600 cursor-pointer transition-colors">Growth</span>
          </div>
        </nav>

        {/* Hero / Form Section */}
        <div className="pt-12 pb-20">
          <ClientInquiryForm />
        </div>

        {/* SEO/Content Section */}
        <SEOSection />

        {/* Corporate Footer */}
        <footer className="border-t border-slate-200 py-24 text-center bg-white/50 backdrop-blur-md">
          <div className="mb-8">
            <span className="text-2xl font-black text-slate-900 tracking-tighter">
              Shawn Ryder <span className="text-indigo-600">Digital</span>
            </span>
          </div>
          <p className="text-slate-500 text-base max-w-md mx-auto px-6 font-medium mb-12">
            Bespoke digital architecture for forward-thinking brands. 
            Available for global collaborations.
          </p>
          <div className="flex justify-center gap-6 mb-12">
            <div className="w-10 h-10 rounded-full border border-slate-200 bg-white shadow-sm flex items-center justify-center text-slate-500 hover:text-indigo-600 hover:border-indigo-200 transition-all cursor-pointer">
              <span className="text-xs font-bold">LI</span>
            </div>
            <div className="w-10 h-10 rounded-full border border-slate-200 bg-white shadow-sm flex items-center justify-center text-slate-500 hover:text-indigo-600 hover:border-indigo-200 transition-all cursor-pointer">
              <span className="text-xs font-bold">X</span>
            </div>
            <div className="w-10 h-10 rounded-full border border-slate-200 bg-white shadow-sm flex items-center justify-center text-slate-500 hover:text-indigo-600 hover:border-indigo-200 transition-all cursor-pointer">
              <span className="text-xs font-bold">GH</span>
            </div>
          </div>
          <div className="text-slate-400 text-[10px] uppercase tracking-[0.5em] font-black">
            &copy; {new Date().getFullYear()} Shawn Ryder Digital &bull; All Systems Operational
          </div>
        </footer>
      </main>
    </div>
  );
}

export default App;